import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { MaterialsSection } from "@/components/MaterialsSection";
import { MaterialsCoverage } from "@/components/MaterialsCoverage";
import { PurchaseOrders } from "@/components/materials/PurchaseOrders";
import { StockMovesLog } from "@/components/materials/StockMovesLog";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Loader2 } from "lucide-react";

const HINTS = {
  tessuti: "I tessuti sono raggruppati per tipo: ogni fornitore può chiamare lo stesso tessuto in modo diverso. Clicca una riga per vedere colori e varianti.",
  accessori: "Ogni accessorio raggruppa le sue varianti per colore e fornitore: clicca una riga per vederle.",
  ordini: "Segna qui tessuti e accessori ordinati. Quando arrivano premi \"Arrivato\": la quantità viene caricata nel magazzino.",
};

export default function MateriePrime() {
  const [tab, setTab] = useState("tessuti");
  const [actionsEl, setActionsEl] = useState(null);
  const { data: materials = [], isLoading } = useQuery({ queryKey: ["materials"], queryFn: async () => (await api.get("/materials")).data });
  const lists = { tessuti: materials.filter((m) => m.type === "tessuto"), accessori: materials.filter((m) => m.type !== "tessuto") };
  return (
    <div data-testid="materie-prime-page">
      <PageHeader title="Materie prime" subtitle={<>Magazzino tessuti e accessori.{HINTS[tab] && <span className="ml-1" data-testid="materials-hint">{HINTS[tab]}</span>}</>} />
      <Tabs value={tab} onValueChange={setTab}>
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <TabsList className="max-w-full justify-start overflow-x-auto">
          <TabsTrigger value="tessuti" data-testid="tab-tessuti">Tessuti</TabsTrigger>
          <TabsTrigger value="accessori" data-testid="tab-accessori">Accessori</TabsTrigger>
          <TabsTrigger value="ordini" data-testid="tab-ordini-fornitori">Ordini fornitori</TabsTrigger>
          <TabsTrigger value="copertura" data-testid="tab-copertura">Copertura materiali</TabsTrigger>
          <TabsTrigger value="scarichi" data-testid="tab-scarichi">Scarichi</TabsTrigger>
        </TabsList>
          <div ref={setActionsEl} className="flex gap-2" data-testid="materials-tab-actions" />
        </div>
        <TabsContent value="ordini"><PurchaseOrders materials={materials} actionsEl={actionsEl} /></TabsContent>
        <TabsContent value="copertura"><MaterialsCoverage /></TabsContent>
        <TabsContent value="scarichi"><StockMovesLog /></TabsContent>
        {Object.entries(lists).map(([k, list]) => (
          <TabsContent key={k} value={k}>
            {isLoading ? (
              <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
            ) : (
              <MaterialsSection kind={k} materials={list} />
            )}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
